module.exports = __webpack_public_path__ + "img/shape-3@2x.4fcc7c2a.png";